module.exports = __webpack_public_path__ + "img/escalier_marche_2.ef6bec63.svg";